"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _path;
var ArrowRight = function ArrowRight(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    d: "M76.673 53L52.945 76.027a2 2 0 0 0-.037 2.833l4.194 4.29a2 2 0 0 0 2.823.035l34.728-33.75a2 2 0 0 0 0-2.87l-34.728-33.75a2 2 0 0 0-2.823.036l-4.194 4.289a2 2 0 0 0 .037 2.833L76.673 43H2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h74.673z",
    fill: "currentColor"
  })));
};
var _default = exports.default = ArrowRight;